import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/content/img/Blue.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-d0a397ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "federal-bar-links" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "bell-logo-margin-left",
  alt: "bell logo",
  width: "60",
  height: "auto"
}, null, -1))

import { useI18n } from "vue-i18n";
import router from "@/router";
import { useStore } from "vuex";

export default /*#__PURE__*/_defineComponent({
  __name: 'NavBar',
  setup(__props) {

const store = useStore();
const { locale } = useI18n();
const { t } = useI18n();

const toggleLanguage = () => {
  store.commit("setAuth", false);
  const newLocale = locale.value === "en" ? "fr" : "en";
  const currHost = window.location.host;
  const newHost =
    newLocale === "fr"
      ? process.env.VUE_APP_FRENCH_HOST != undefined
        ? process.env.VUE_APP_FRENCH_HOST
        : window.location.host
      : process.env.VUE_APP_ENGLISH_HOST != undefined
      ? process.env.VUE_APP_ENGLISH_HOST
      : window.location.host;
  const currentUrl = new URL(window.location.href);
  let newUrl = currentUrl.href.replace(currHost, newHost);

  if (
    window.location.pathname.includes("/download") ||
    window.location.pathname.includes("/invoice-download") ||
    window.location.pathname.includes("/subscriber") ||
    window.location.pathname.includes("/validate")
  ) {
    newUrl =
      newLocale === "fr"
        ? process.env.VUE_APP_FRENCH_PATH + `?p=${store.state.userID}`
        : process.env.VUE_APP_ENGLISH_PATH + `?p=${store.state.userID}`;
  }
  window.location.replace(newUrl);
};

const notifyHome = () => {
  store.commit("setAuth", false);
  router.push({ name: "HomePage", query: { p: store.state.userID } });
};

return (_ctx: any,_cache: any) => {
  const _component_b_navbar_nav = _resolveComponent("b-navbar-nav")!
  const _component_b_navbar = _resolveComponent("b-navbar")!
  const _component_b_navbar_brand = _resolveComponent("b-navbar-brand")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_b_navbar, {
      type: "dark",
      variant: "dark",
      class: "top-nav-height"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_b_navbar_nav, { class: "ml-auto" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("a", {
                  role: "button",
                  onClick: toggleLanguage
                }, _toDisplayString(_unref(t)("navbar.buttonText")), 1)
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_b_navbar, {
      toggleable: "",
      type: "dark",
      variant: "dark",
      class: "navbar-color p-3"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_b_navbar_brand, { onClick: notifyHome }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})